import { render, staticRenderFns } from "./Wwdc2022.vue?vue&type=template&id=cca990ba&scoped=true&"
var script = {}
import style0 from "./Wwdc2022.vue?vue&type=style&index=0&id=cca990ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca990ba",
  null
  
)

export default component.exports